import classnames from 'classnames'

import '@hotmart/cosmos/dist/content-loader'

interface Props {
  className?: string,
  width: number,
  height: number
}

const ContentLoader = ({ className, width, height }: Props) => (
  <hot-content-loader class={classnames('content-loader', className)} style={{ width, height }} />
)

export default ContentLoader
